import initializeScenarioStore from '../actions/initializeScenarioStore';
import getStore, { createDefaultSearchStore } from '../store/store';
import { getScenarioIdKey } from 'owa-search-next-common';
import { mutator } from 'satcheljs';
import {
    lazyGetSearchStore,
    lazyGetSearchBoxContent,
    lazyIsSearchSessionActive,
    lazyIsSearchBoxEmpty,
    lazyQueryIncludesKQLSuggestion,
} from 'owa-search-next-lazy';

mutator(initializeScenarioStore, actionMessage => {
    const scenarioIdKey = getScenarioIdKey(actionMessage.scenarioId);

    /**
     * If instance store already exists, return as the store is already
     * initialized.
     */
    if (getStore().scenarioStores.get(scenarioIdKey)) {
        return;
    }

    // Initialize instance store with default values.
    getStore().scenarioStores.set(scenarioIdKey, { ...createDefaultSearchStore() });
    const instanceStore = getStore().scenarioStores.get(scenarioIdKey);

    // Set isUsing3S value based on action message.
    instanceStore.isUsing3S = actionMessage.isUsing3S;

    /**
     * This parses the lazy functions and makes them available
     * synchronously later.
     */
    lazyGetSearchStore.import();
    lazyGetSearchBoxContent.import();
    lazyIsSearchSessionActive.import();
    lazyIsSearchBoxEmpty.import();
    lazyQueryIncludesKQLSuggestion.import();
});
